// extracted by mini-css-extract-plugin
export default {"wrapper":"Cards_wrapper__7sCiF","cards":"Cards_cards__O6wuG"};